import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { rp, fmtDate, fmtAcc } from "./format";

export function downloadMutasi(user, data) {
  const doc = new jsPDF();
  doc.setFillColor(30, 64, 175);
  doc.rect(0, 0, 210, 28, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(16);
  doc.text("CU TUAH TALINO", 14, 13);
  doc.setFontSize(9);
  doc.text("Koperasi Simpan Pinjam - Mutasi Buku Tabungan", 14, 20);
  doc.setTextColor(15, 23, 42);
  doc.setFontSize(10);
  doc.text(`Nama: ${user.name}`, 14, 38);
  doc.text(`No. Anggota: ${user.member_no}   No. Rekening: ${fmtAcc(user.account_no)}`, 14, 44);
  doc.text(`Dicetak: ${fmtDate(new Date().toISOString())}`, 14, 50);
  const b = data.balances;
  doc.text(`Pokok: ${rp(b.pokok)}   Wajib: ${rp(b.wajib)}   Sukarela: ${rp(b.sukarela)}   Total: ${rp(b.total)}`, 14, 58);
  autoTable(doc, {
    startY: 64,
    head: [["Tanggal", "Keterangan", "Jenis", "Masuk", "Keluar"]],
    body: data.transactions.map((t) => [
      fmtDate(t.created_at), t.description, t.type,
      t.direction === "in" ? rp(t.amount) : "-", t.direction === "out" ? rp(t.amount) : "-",
    ]),
    headStyles: { fillColor: [220, 38, 38] },
    styles: { fontSize: 8 },
  });
  doc.save(`mutasi-${user.member_no}.pdf`);
}
